/* eslint-disable n/callback-return */

let userActive = false;
let callbacks: Array<() => void> = [];

// Function to handle user activity
const internalOnUserActive = () => {
  // Remove event listeners after the first interaction
  window.removeEventListener('scroll', internalOnUserActive);
  window.removeEventListener('mousemove', internalOnUserActive);
  window.removeEventListener('touchstart', internalOnUserActive);
  window.removeEventListener('keydown', internalOnUserActive);
  window.removeEventListener('click', internalOnUserActive);

  userActive = true;

  for (const callback of callbacks) {
    callback();
  }

  callbacks = [];
};

if (typeof window !== 'undefined') {
  window.addEventListener('scroll', internalOnUserActive, { once: true });
  window.addEventListener('mousemove', internalOnUserActive, { once: true });
  window.addEventListener('touchstart', internalOnUserActive, { once: true });
  window.addEventListener('keydown', internalOnUserActive, { once: true });
  window.addEventListener('click', internalOnUserActive, { once: true });
}

export const onUserActive = (callback: () => void) => {
  if (userActive) {
    callback();
  } else {
    callbacks.push(callback);
  }
};
